import React from 'react'
import './styles.css'
import FixWidthContainer from '../../atoms/fixWidthContainer'
import logo from '../../../assets/img/logo.png'
import Spacer from '../../atoms/Spacer'
import instagram from '../../../assets/img/instagram.png'
import whatsapp from '../../../assets/img/whatsapp2.png'

export default function Footer() {
  const [isMobile, setIsMobile] = React.useState(false)

  const handleWhatsAppRedirect = () => {
    const phoneNumber = '+553193716866'
    const message = 'Olá, gostaria de agendar uma consulta.' // Mensagem pré-preenchida (opcional)
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
      message,
    )}`

    window.open(whatsappUrl)
  }

  React.useEffect(() => {
    if (window.innerWidth < 768) {
      setIsMobile(true)
    }
  }, [])

  return (
    <footer className="footer-container">
      {isMobile ? (
        <FixWidthContainer flexDirection={'column'} alignItems="center">
          {isMobile ? (
            <div className="about-us">
              <div>
                <p> E-mail: clinicapedrabonita@gmail.com</p>
                <p> Telefone: (31)9371-6866</p>
                <div className="social-media-container">
                  <p>Redes Sociais:</p>
                  <img
                    src={instagram}
                    alt="instagram"
                    height={22}
                    width={20}
                    onClick={() =>
                      window.open(
                        'https://www.instagram.com/gabrielapinheiro_pediatra/',
                        '_blank',
                      )
                    }
                  />
                  <img src={whatsapp} alt="whatsapp" height={20} width={20} />
                </div>
              </div>
            </div>
          ) : (
            <div className="about-us">
              <p>
                {' '}
                E-mail:{' '}
                <p style={{ fontSize: '5px' }}>clinicapedrabonita@gmail.com</p>
              </p>
              <p> Telefone: (31)9371-6866</p>
              <p> Telefone: (31) 99371-6866</p>
              <div className="social-media-container">
                <p>Redes Sociais:</p>
                <img
                  src={instagram}
                  alt="instagram"
                  height={22}
                  width={20}
                  onClick={() =>
                    window.open(
                      'https://www.instagram.com/gabrielapinheiro_pediatra/',
                      '_blank',
                    )
                  }
                />
                  <img src={whatsapp} alt="whatsapp" height={20} width={20} onClick={handleWhatsAppRedirect}  />
              </div>
              <Spacer size={10} />
              {/* <p>Serviços</p>
              <p>Sobre nós</p>
              <p>Contato</p>
              <p>Atendimentos</p> */}
            </div>
          )}

          <div className="location-container">
            <p>Rua Pedra Bonita 684, Prado</p>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3750.8823627973393!2d-43.96799158832372!3d-19.929361481381644!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xa697149dfdab53%3A0xbb6cf59bfcb4e856!2sGabriela%20Pinheiro%20-%20Pediatra!5e0!3m2!1spt-BR!2sbr!4v1726518764739!5m2!1spt-BR!2sbr"
              width="300"
              height="130"
              style={{ border: 0, borderRadius: 28, marginBottom: '20px' }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </FixWidthContainer>
      ) : (
        <FixWidthContainer flexDirection={'row'} alignItems="center">
          <div className="logo-container">
            <img src={logo} alt="logo" />
          </div>

          {isMobile ? (
            <div className="about-us">
              <div>
                <p> E-mail: clinicapedrabonita@gmail.com</p>
                <p> Telefone: (31)9371-6866</p>
                <p> Redes Sociais</p>
              </div>
              <Spacer size={10} />
              <div>
                <p>Serviços</p>
                <p>Sobre nós</p>
                <p>Contato</p>
                <p>Atendimentos</p>
              </div>
            </div>
          ) : (
            <div className="about-us">
              <p>
                {' '}
                E-mail: <b>clinicapedrabonita@gmail.com</b>
              </p>
              <p> Telefone: (31) 99371-6866</p>
              <div className="social-media-container">
                <p>Redes Sociais:</p>
                <img
                  src={instagram}
                  alt="instagram"
                  height={22}
                  width={20}
                  onClick={() =>
                    window.open(
                      'https://www.instagram.com/gabrielapinheiro_pediatra/',
                      '_blank',
                    )
                  }
                />
                <img src={whatsapp} alt="whatsapp" height={20} width={20} onClick={handleWhatsAppRedirect} />
              </div>

              <Spacer size={10} />
            </div>
          )}

          <div className="location-container">
            <p>Rua Pedra Bonita 684, Prado</p>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3750.8823627973393!2d-43.96799158832372!3d-19.929361481381644!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xa697149dfdab53%3A0xbb6cf59bfcb4e856!2sGabriela%20Pinheiro%20-%20Pediatra!5e0!3m2!1spt-BR!2sbr!4v1726518764739!5m2!1spt-BR!2sbr"
              width="300"
              height="130"
              style={{ border: 0, borderRadius: 28, marginBottom: '20px' }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </FixWidthContainer>
      )}
      <div className="footer-text">
        GABRIELA PINHEIRO PEDIATRA - TODOS OS DIREITOS RESERVADOS
      </div>
    </footer>
  )
}
